import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from 'sweetalert2';
import CustomSelect from "components/Common/custom-select";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchActiveLoanTypes, fetchActiveEmployees, fetchempLoannumber, fetchloaninstallments, saveEmployeeLoandetails, clearapproveError } from "store/actions";
import CustomDatePicker from "common/CustomDatePicker";
import Loader from "common/pageLoader";

const PayrollCreateLoan = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [employeeDataSelected, setEmployeeDataSelected] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [month, setMonth] = useState(null);
  const [installment, setInstallments] = useState([]);
  const [data, setData] = useState([]);
  const location = useLocation();
  const history = useHistory();
  const authUserDetails = useAuthUserDetails();

  const {
    loantype,
    employees,
    loannumber,
    installments,
    saveSuccess,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    employees: state.EmployeeDetailsReducer?.employeesActiveList ?? [],
    loantype: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.loantype ?? [],
    loannumber: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.loannumber ?? [],
    installments: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.installments ?? [],
    loading: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.loading,
    error: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.error,
    success: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.success,
    saveSuccess: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.saveSuccess,
  }));

  useEffect(() => {
    if (!authUserDetails || !authUserDetails.length) return;

    const unitId = authUserDetails[0]?.unit_id;

    if (unitId) {
      dispatch(fetchActiveLoanTypes(unitId));
      dispatch(fetchActiveEmployees(unitId));
    }
  }, [dispatch]);

  let loan_type = [];
  loan_type = (loantype || []).map(item => ({ label: item.loan_name, value: item.loan_id }));

  const findEmpgetloannumber = (empData) => {
    if (empData) {
      const formData = new FormData();
      formData.append("emp_id", employeeDataSelected.value);
      formData.append("type", empData.value);
      formData.append("unit_id", authUserDetails[0]?.unit_id);
      dispatch(fetchempLoannumber(formData));
    }
  }

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: {
      employee: "",
      loan_types: "",
      loan_Number: "",
      amount: "",
      interest: "",
      paymentStartMonth: null,
      payableAmount: "",
      installments: "",
      totalAmount: "0",
      remarks: "",
    },
    validationSchema: Yup.object().shape({
      employee: Yup.object().required("Employee is required"),
      loan_types: Yup.object().required("Loan Type is required"),
      loan_Number: Yup.string().required("Number is required"),
      amount: Yup.number().required("Amount is required"),
      interest: Yup.number().required("Interest % is required"),
      paymentStartMonth: Yup.date().nullable().required("Payment Start Month is required"),
      payableAmount: Yup.number().required("Payable Amount is required"),
      installments: Yup.number().required("Installments is required"),
      totalAmount: Yup.number().required("Total Amount is required"),
      remarks: Yup.string().required("Remarks is required"),
    }),
    onSubmit: (values) => {
      // console.log("Form Data", values);
      const selecteddata = data.map(row => ({
        pay_dtl_id: 0,
        installment_period: row.installment_period,
        payable_date: row.payable_date ? formatYearMonth(row.payable_date) : null,
        installment_amount: row.installment_amount,
        current_balance: row.current_balance,
        loan_interest: row.interest_amount,
        principal_amount: row.principal_amount,
      }));

      let result = { sch: selecteddata };

      const formData = new FormData();
      formData.append("emp_id", values.employee.value);
      formData.append("loan_type_id", values.loan_types.value);
      formData.append("loan_no", values.loan_Number);
      formData.append("loan_amount", values.amount);
      formData.append("loan_interest", values.interest);
      formData.append("loan_startdate", values.paymentStartMonth);
      formData.append("payable_amount", values.payableAmount);
      formData.append("loan_installments", values.installments);
      formData.append("total_loan_amount", values.totalAmount || 0);
      formData.append("remarks", values.remarks);
      formData.append("lst_employee_loan", JSON.stringify(result));
      formData.append("create_by", authDetails?.user_id);
      formData.append("unit_id", authDetails?.unit_id);
      dispatch(saveEmployeeLoandetails(formData));
      handleReset();
    },
  });

  const formatYearMonth = (date) => {
    if (!date) return null;
    const [day, month, year] = date.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  useEffect(() => {
    setInstallments([]);
    if (loannumber?.length > 0) { formik.setFieldValue("loan_Number", loannumber[0]?.Number || ""); }

    if (installments?.length > 0) { setInstallments(installments) }
  }, [loannumber, installments]);

  const handleCalculate = () => {
    const formData = new FormData();
    formData.append("emp_id", formik.values.employee.value);
    formData.append("loan_type_id", formik.values.loan_types.value);
    formData.append("loan_amount", formik.values.amount);
    formData.append("loan_interest", formik.values.interest);
    formData.append("loan_startdate", formik.values.paymentStartMonth);
    formData.append("payable_amount", formik.values.payableAmount);
    formData.append("loan_installments", formik.values.installments);
    formData.append("total_loan_amount", formik.values.totalAmount);
    formData.append("remarks", formik.values.remarks);
    dispatch(fetchloaninstallments(formData));
  }

  useEffect(() => {
    if (installment?.length > 0) {
      let totalAmount = 0
      const generatedData = installment.map((emp, index) => ({
        sno: index + 1,
        current_balance: emp.current_balance,
        installment_amount: emp.installment_amount,
        installment_period: emp.installment_period,
        interest_amount: emp.interest_amount,
        payable_date: emp.payable_date,
        principal_amount: emp.principal_amount
      })) || [];

      totalAmount = generatedData.reduce((sum, row) => sum + Number(row.installment_amount || 0), 0);
      formik.setFieldValue("totalAmount", totalAmount.toFixed(2) || 0);
      setData(generatedData);
    } else {
      setData([]);
    }
  }, [installment]);

  const columns = [
    { Header: "Date", accessor: "payable_date" },
    { Header: "Principal", accessor: "principal_amount" },
    { Header: "Recovery Amt", accessor: "installment_amount" },
    { Header: "Installment Interest", accessor: "interest_amount" },
    { Header: "Installment Amt", accessor: "installment_period" },
    { Header: "Balance Principal", accessor: "current_balance" },
  ];

  const handleReset = () => {
    dispatch({ type: "RESET_SAVE_STATUS" });
    formik.resetForm({
      values: {
        employee: "",
        loan_types: "",
        loan_Number: "",
        amount: "",
        interest: "",
        paymentStartMonth: null,
        payableAmount: "",
        installments: "",
        totalAmount: "0",
        remarks: ""
      }
    });

    // setInstallments([]);
    setEmployeeDataSelected(null);
    // setData([]);
  };

  const [isEnabled, setisEnabled] = useState(false);
  const calulatepayableamount = (e) => {
    const amount = Number(formik.values.amount) || 0;
    const interest = Number(formik.values.interest) || 0;

    let payable_amount = 0;
    if (interest > 0) {
      payable_amount = amount + (amount * interest / 100);
    } else {
      payable_amount = amount;
    }

    if (amount > 0) { setisEnabled(true) };
    formik.setFieldValue("payableAmount", payable_amount);
  }

  useEffect(() => {
    if (saveSuccess) {
      history.push("/payroll-loan-apply");
      dispatch({ type: "RESET_SAVE_STATUS" });
    }
  }, [saveSuccess, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearapproveError());
    };
  }, []);

  return (
    <React.Fragment>
      <Loader loading={loading} />
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumbs */}
          <Breadcrumbs title="Payroll" breadcrumbItem="Create Loan" />

          {/* Input Section */}
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="mb-3 g-3 align-items-center">

                  {/* Employee */}
                  <Col md="4">
                    <FormGroup>
                      <Label>Employee <span className="text-danger">*</span></Label>
                      <CustomSelect
                        id="employee"
                        name="employee"
                        isMulti={false}
                        options={employees}
                        value={employeeDataSelected}
                        onChange={(selectedOption) => { setEmployeeDataSelected(selectedOption); formik.setFieldValue("employee", selectedOption); }}
                        onBlur={() => formik.setFieldTouched("employee", true)}
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                      {formik.touched.employee && formik.errors.employee && (
                        <div className="text-danger">{formik.errors.employee}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Loan Type */}
                  <Col md="4">
                    <FormGroup>
                      <Label>Loan Type <span className="text-danger">*</span></Label>
                      <CustomSelect
                        id="loan_types"
                        name="loan_types"
                        isMulti={false}
                        options={loan_type || []}
                        value={formik.values.loan_types || null}
                        onChange={(selectedOption) => { formik.setFieldValue("loan_types", selectedOption); findEmpgetloannumber(selectedOption); }}
                        onBlur={() => formik.setFieldTouched("loan_types", true)}
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                      {formik.touched.loan_types && formik.errors.loan_types && (
                        <div className="text-danger">{formik.errors.loan_types}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Number */}
                  <Col md="4">
                    <FormGroup>
                      <Label>Number <span className="text-danger">*</span></Label>
                      <Input
                        type="text"
                        name="loan_Number"
                        disabled
                        value={formik.values.loan_Number}
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.loan_Number && formik.errors.loan_Number && (
                        <div className="text-danger">{formik.errors.loan_Number}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Amount */}
                  <Col md="4">
                    <FormGroup>
                      <Label>Amount <span className="text-danger">*</span></Label>
                      <Input
                        type="text"
                        maxLength={6}
                        name="amount"
                        value={formik.values.amount}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        onKeyDown={(e) => {
                          if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                            e.preventDefault();
                          }
                        }}
                        onInput={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          formik.setFieldValue(`amount`, value);
                        }}
                        invalid={formik.touched.amount && Boolean(formik.errors.amount)}
                      />
                      {formik.touched.amount && formik.errors.amount && (
                        <div className="text-danger">{formik.errors.amount}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Interest % */}
                  <Col md="4">
                    <FormGroup>
                      <Label>Interest % <span className="text-danger">*</span></Label>
                      <Input
                        type="text"
                        maxLength={2}
                        name="interest"
                        value={formik.values.interest}
                        onChange={(e) => { formik.handleChange(e); }}
                        onBlur={(e) => { formik.handleBlur(e); calulatepayableamount(e.value); }}
                        onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];
                          if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onInput={(e) => { const value = e.target.value.replace(/[^0-9]/g, ""); formik.setFieldValue(`interest`, value); }}
                        invalid={formik.touched.interest && Boolean(formik.errors.interest)}
                      />
                      {formik.touched.interest && formik.errors.interest && (
                        <div className="text-danger">{formik.errors.interest}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Payment Start Month */}
                  <Col md="4">
                    <FormGroup>
                      <Label>Payment Start Month <span className="text-danger">*</span></Label>
                      <CustomDatePicker
                        value={formik.values.paymentStartMonth}
                        onChange={(date) => formik.setFieldValue("paymentStartMonth", date)}
                        onBlur={() => formik.setFieldTouched("paymentStartMonth", true)}
                        disableFuture={true}
                      />
                      {formik.touched.paymentStartMonth && formik.errors.paymentStartMonth &&
                        (<div className="text-danger">
                          {formik.errors.paymentStartMonth}
                        </div>)}
                    </FormGroup>
                  </Col>

                  {/* Payable Amount */}
                  <Col md="4">
                    <FormGroup>
                      <Label>Payable Amount <span className="text-danger">*</span></Label>
                      <Input
                        type="text"
                        name="payableAmount"
                        disabled
                        value={formik.values.payableAmount}
                        onChange={formik.handleChange}
                        onKeyDown={(e) => { if (!/[0-9]/.test(e.key) && e.key !== "Backspace") { e.preventDefault(); } }}
                        onInput={(e) => { const value = e.target.value.replace(/[^0-9]/g, ""); formik.setFieldValue(`payableAmount`, value); }}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.payableAmount && Boolean(formik.errors.payableAmount)}
                      />
                      {formik.touched.payableAmount && formik.errors.payableAmount && (
                        <div className="text-danger">{formik.errors.payableAmount}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Installments */}
                  <Col md="4">
                    <FormGroup>
                      <Label>Installments <span className="text-danger">*</span></Label>
                      <Input
                        type="text"
                        name="installments"
                        maxLength={2}
                        value={formik.values.installments}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        onKeyDown={(e) => { if (!/[0-9]/.test(e.key) && e.key !== "Backspace") { e.preventDefault(); } }}
                        onInput={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          formik.setFieldValue(`installments`, value);
                        }}
                        invalid={formik.touched.installments && Boolean(formik.errors.installments)}
                      />
                      {formik.touched.installments && formik.errors.installments && (
                        <div className="text-danger">{formik.errors.installments}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Total Amount */}
                  <Col md="4">
                    <FormGroup>
                      <Label>Total Amount <span className="text-danger">*</span></Label>
                      <Input
                        type="text"
                        name="totalAmount"
                        maxLength={6}
                        value={formik.values.totalAmount}
                        disabled
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        onKeyDown={(e) => { if (!/[0-9]/.test(e.key) && e.key !== "Backspace") { e.preventDefault(); } }}
                        onInput={(e) => { const value = e.target.value.replace(/[^0-9]/g, ""); formik.setFieldValue(`totalAmount`, value); }}
                        invalid={formik.touched.totalAmount && Boolean(formik.errors.totalAmount)}
                      />
                      {formik.touched.totalAmount && formik.errors.totalAmount && (
                        <div className="text-danger">{formik.errors.totalAmount}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Remarks */}
                  <Col md="4">
                    <FormGroup>
                      <Label>Remarks <span className="text-danger">*</span></Label>
                      <Input
                        type="text"
                        name="remarks"
                        maxLength={100}
                        value={formik.values.remarks}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.remarks && Boolean(formik.errors.remarks)}
                      />
                      {formik.touched.remarks && formik.errors.remarks && (
                        <div className="text-danger">{formik.errors.remarks}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Buttons */}
                  <Col className="d-flex align-items-center justify-content-end mt-4">
                    {Number(formik.values.amount) > 0 && (
                      <>
                        <Button
                          type="button"
                          color="primary"
                          className="btn button-save me-2"
                          onClick={handleCalculate}
                        >
                          <i className="fas fa-calculator me-1" /> Calculate
                        </Button>
                      </>
                    )}
                    <Button type="submit" className="btn button-save me-2"><i className="fas fa-save me-1" /> SAVE</Button>

                    <Button type="reset" className="btn button-cancel"
                      onClick={() => {
                        Swal.fire({
                          title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                          showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                        }).then((result) => {
                          if (result.isConfirmed) {
                            //  formik.resetForm 
                            handleReset();
                          }
                        });
                      }}
                    >
                      <i className="fas fa-sync me-1" /> CANCEL
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>

          {/* Table Section */}
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={data && data?.length > 0 ? data : []}
                isGlobalFilter={true}
                customPageSize={10}
              // className="custom-header-css"
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PayrollCreateLoan;
